import { dictionaryApi } from './dictionaryClient';

/** Tiṅganta scalar fields (API: all strings). */
export type TingantaScalars = {
  i: string;
  baseindex: string;
  dhatu: string;
  aupadeshik: string;
  gana: string;
  pada: string;
  settva: string;
  karma: string;
  artha: string;
  artha_english: string;
  tags: string;
  dhaturoopnandini: string;
  sk: string;
  lsk_sutra: string;
  sk_sutra: string;
  artha_hindi: string;
  antarganas: string;
  dhaturoopnandini_note: string;
};

export const TINGANTA_SCALAR_KEYS: (keyof TingantaScalars)[] = [
  'i',
  'baseindex',
  'dhatu',
  'aupadeshik',
  'gana',
  'pada',
  'settva',
  'karma',
  'artha',
  'artha_english',
  'tags',
  'dhaturoopnandini',
  'sk',
  'lsk_sutra',
  'sk_sutra',
  'artha_hindi',
  'antarganas',
  'dhaturoopnandini_note',
];

export type Tinganta = TingantaScalars & {
  id: number;
  createdAt?: string;
  updatedAt?: string;
  created_at?: string;
  updated_at?: string;
};

export type CreateTingantaBody = TingantaScalars;

function normalizeList(data: unknown): Tinganta[] {
  if (Array.isArray(data)) return data as Tinganta[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: Tinganta[] }).data;
  }
  return [];
}

export async function listTingantas(): Promise<Tinganta[]> {
  const res = await dictionaryApi.get<unknown>('/tinganta');
  return normalizeList(res.data);
}

export async function getTinganta(id: number): Promise<Tinganta> {
  const res = await dictionaryApi.get<Tinganta>(`/tinganta/${id}`);
  return res.data;
}

export async function createTinganta(body: CreateTingantaBody): Promise<Tinganta> {
  const res = await dictionaryApi.post<Tinganta>('/tinganta', body);
  return res.data;
}

export async function updateTinganta(
  id: number,
  body: Partial<TingantaScalars>
): Promise<Tinganta> {
  const res = await dictionaryApi.patch<Tinganta>(`/tinganta/${id}`, body);
  return res.data;
}

export async function deleteTinganta(id: number): Promise<void> {
  await dictionaryApi.delete(`/tinganta/${id}`);
}

/** Normalize form values so every scalar is a string (empty when unset). */
export function normalizeTingantaScalars(
  values: Partial<Record<keyof TingantaScalars, unknown>>
): TingantaScalars {
  const out = {} as TingantaScalars;
  for (const key of TINGANTA_SCALAR_KEYS) {
    const v = values[key];
    out[key] = v == null ? '' : String(v);
  }
  return out;
}
